
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M480.4 444l-9.9 9.9-3.9 3.8c-6.2 6-16.9 14.4-32.6 20.5-8.9 3.4-17.6 5.6-26.6 6.7-1.1.1-112.8 9.6-251.1-128.6C38.8 238.7 20 171 27.9 105.4c1-8.7 3.2-17.4 6.7-26.6C40.7 63 49.1 52.3 55.1 46.1l13.7-13.8c6.6-6.6 16.9-7.1 22.9-1.1l78.5 78.5c6 6 5.5 16.3-1.1 22.9l-53 53 4.9 8.2c2.7 4.6 5.6 9.7 8.7 15.3 14.6 26.3 34.5 62.3 73.1 100.8 38.4 38.5 74.4 58.4 100.6 73 5.7 3.1 10.8 6 15.5 8.8l8.2 4.9 53-53c6.6-6.6 16.9-7.1 22.9-1.1l78.5 78.5c6 6.1 5.5 16.4-1.1 23z"}})])
          )
        }
      }
    